import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { lightColours } from '../../../../styles/colours';

export const MobileTaxBrackets = ({
  bracketDetails,
  TAX_BANDS,
  darkMode,
  currentBracketIndex,
}) => {
  const captionWidth = 80; // fixed caption width in pixels
  
  // Calculate total taxable income across all brackets
  const totalSalary = bracketDetails.reduce(
    (sum, { taxableAmount }) => sum + taxableAmount,
    0
  );
  
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        backgroundColor: darkMode ? '#333' : lightColours.lightGrey,
        position: 'relative',
        transition: 'background-color 0.3s ease',
      }}
    >
        {/* Heading for Tax Brackets */}
        <Typography
        variant="h6"
        sx={{ backgroundColor: 'white', pt:1, pb:1, textAlign: 'left', fontWeight: 'bold', color: darkMode ? '#fff' : '#222' }}
        >
        Tax Brackets
        </Typography>

      {bracketDetails.map(({ rate, taxableAmount, tax }, index) => {
        if (
          !TAX_BANDS[index] ||
          TAX_BANDS[index].min === undefined ||
          TAX_BANDS[index].max === undefined
        ) {
          console.error(`Invalid tax band at index ${index}:`, TAX_BANDS[index]);
          return null;
        }
  
        // If it's the 0% bracket with a value of zero, skip rendering it.
        if (rate === 0 && taxableAmount === 0) {
          return null;
        }
  
        // Calculate the bar's width as a percentage of the total salary
        const barPercentage =
          taxableAmount > 0 ? (taxableAmount / totalSalary) * 100 : 0;
  
        // Calculate inner bar percentages relative to the bracket’s taxable amount
        const takeHomePercent =
          taxableAmount > 0 ? ((taxableAmount - tax) / taxableAmount) * 100 : 0;
        const taxPaidPercent =
          taxableAmount > 0 ? (tax / taxableAmount) * 100 : 0;
  
        return (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              border: `2px solid ${darkMode ? '#444' : '#fff'}`,
              boxSizing: 'border-box',
              transition: 'border-color 0.3s ease',
            }}
          >
            {/* Fixed-width caption */}
            <Typography
              variant="caption"
              sx={{
                width: captionWidth,
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: '1rem',
                color: darkMode ? '#fff' : '#222',
                opacity: index <= currentBracketIndex ? 1 : 0.3,
              }}
            >
              {rate === 0 ? '0%' : `${rate}%`}
            </Typography>
  
            {/* Bar container */}
            <Box
              sx={{
                width: barPercentage > 100 ? '100%' : `${barPercentage}%`,
                height: 40,
                position: 'relative',
              }}
            >
              <Box sx={{ display: 'flex', height: '100%' }}>
            <Tooltip
                title={`Take Home: £${(taxableAmount - tax).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}`}
                arrow
                >
                <Box
                    sx={{
                    backgroundColor: lightColours.midBlue,
                    width: `${takeHomePercent}%`,
                    height: '100%',
                    }}
                />
                </Tooltip>
                <Tooltip
                title={`Tax Paid: £${tax.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })}`}
                arrow
                >
                <Box
                    sx={{
                    backgroundColor: lightColours.darkBlue,
                    width: `${taxPaidPercent}%`,
                    height: '100%',
                    }}
                />
                </Tooltip>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
